import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "home-section",
  id: "vs-home-how-it-works"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "home-how-it-works-title" }, "Confira as vantagens que a Obmed oferece", -1)
const _hoisted_3 = { class: "home-how-it-works-cards" }
const _hoisted_4 = { class: "home-how-it-works-card" }
const _hoisted_5 = { class: "home-how-it-works-card-image-container" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "home-how-it-works-card-title" }
const _hoisted_8 = { class: "home-how-it-works-card-content" }


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const cards = [
  {
    title: "Preços populares",
    content: "Realize o agendamento da sua consulta ou exame à preços acessíveis.",
    image: "discount.svg",
  },
  {
    title: "Agendamento online",
    content:
      "Marque sua consulta ou exame diretamente pela nossa plataforma sem a necessidade de deslocamento para uma unidade física.",
    image: "device-mobile.svg",
  },
  {
    title: "Para toda familia",
    content: "Cuide de quem você ama! Marque consultas ou exames para membros do seu grupo familiar.",
    image: "friends.svg",
  },
  {
    title: "Rede de cobertura",
    content: "Tenha uma vasta rede médica parceira do OBMED à sua disposição.",
    image: "building-hospital.svg",
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cards, (card) => {
        return _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              class: "home-how-it-works-card-image",
              src: require(`@/assets/icons/${card.image}`),
              alt: "imagem"
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("h6", _hoisted_7, _toDisplayString(card.title), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(card.content), 1)
        ])
      }), 64))
    ])
  ]))
}
}

})